export type SlotGameEvents = {
    'General.Game.FIRST_INTERACTION': void;
    'General.Game.ODDS_UPFRONT_ACCEPT': void;
    'General.Game.ODDS_UPFRONT_ACCEPTED': void;
};
